import { DEFAULT_PAGE_SIZE } from '@w7/ui'
import { ApiError, hasLiveApi } from '@/api/client'
import {
  getBetfairRatesLogs,
  toBetfairRatesLogResult,
} from '@/api/map/betfairRatesLogs'
import type { BetfairRatesLogQuery, BetfairRatesLogResult } from './betfairRatesTypes'

/** Empty page when demo / offline — no invented rate-change rows. */
export function emptyBetfairRatesLogs(
  query: BetfairRatesLogQuery = {},
): BetfairRatesLogResult {
  const pageSize = Math.max(1, query.pageSize ?? DEFAULT_PAGE_SIZE)
  const page = Math.max(1, query.page ?? 1)
  return {
    rows: [],
    total: 0,
    page,
    pageSize,
  }
}

/**
 * Live Keycloak → hierarchy `getBetfairRatesLogs`.
 * Demo / no live API → empty (never invent rate / IP history).
 */
export async function loadBetfairRatesLogs(
  query: BetfairRatesLogQuery = {},
): Promise<BetfairRatesLogResult> {
  if (!hasLiveApi()) return emptyBetfairRatesLogs(query)

  try {
    const live = await getBetfairRatesLogs({
      page: query.page ?? 1,
      pageSize: query.pageSize ?? DEFAULT_PAGE_SIZE,
    })
    if (!live.value) return emptyBetfairRatesLogs(query)
    return toBetfairRatesLogResult(live, query)
  } catch (err) {
    const status = err instanceof ApiError ? err.status : 0
    console.warn('[betfair-rates-logs] hierarchy getBetfairRatesLogs unavailable', err)
    if (status === 404) {
      console.warn(
        '[betfair-rates-logs] Agent-API betfair-rates-logs route is not deployed on this hierarchy yet.',
      )
    }
    return emptyBetfairRatesLogs(query)
  }
}
